import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class HotelCondition extends BaseClass {

  constructor(options) {
      super(options, defaultOptions);

      this.init();
  }

  init() {}

  /**
   * This function rewrites free conditions in destination (should be conditions wrapper).
   *
   * @param {Element} destination element its content will be overwritten
   * @param {Array} conditions can be undefined
   */
  static rewriteFreeConditions(destination, conditions) {
    destination = $(destination);

    // Clear the destination
    destination.html('');

    if(conditions !== undefined) {

      conditions.forEach((condition) => {
        let conditionElement = '<p class="' + condition.class + ' weight-medium">';
        conditionElement += condition.text;
        conditionElement += '</p>';

        destination.append(conditionElement);
      });
    }
  }
}
